(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scribal-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
/* Performance: the footer video is only fetched when the visitor scrolls near it,
phones can get a smaller file, and playback pauses whenever it is off screen. */
var roots = document.querySelectorAll('[data-scribal-footer-video-root]');
if (!roots.length) return;

var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var saveData = navigator.connection && navigator.connection.saveData;
var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

roots.forEach(function (root) {
var wrapper = root.closest('.scribal-footer');
var video = root.querySelector('video');
if (!wrapper || !video) return;

var autoplay = wrapper.dataset.autoplay === 'true' && !reduce && !saveData;
var loaded = !video.hasAttribute('data-scribal-src');

function load() {
if (loaded) return;
loaded = true;
var src = (small && video.getAttribute('data-scribal-src-mobile')) || video.getAttribute('data-scribal-src');
if (!src) return;
video.src = src;
video.load();
}
function play() {
var p = video.play();
if (p && typeof p.catch === 'function') p.catch(function () {});
}

if (!('IntersectionObserver' in window)) {
if (autoplay) { load(); play(); }
return;
}

if (autoplay) {
var near = new IntersectionObserver(function (entries) {
if (entries[0].isIntersecting) { load(); near.disconnect(); }
}, { rootMargin: '600px 0px' });
near.observe(video);
}

var vis = new IntersectionObserver(function (entries) {
var e = entries[0];
if (e.isIntersecting) {
if (autoplay) { load(); play(); }
} else if (!video.paused) {
video.pause();
}
}, { threshold: 0.2 });
vis.observe(video);

document.addEventListener('visibilitychange', function () {
if (document.hidden && !video.paused) video.pause();
});
});
})();

  } catch(e) { console.error(e); }
})();
})();
